import React, { useEffect } from "react";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Editorial } from "@/components/sections/Editorial";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Projects } from "@/components/sections/Projects";
import { Value } from "@/components/sections/Value";
import { Stats } from "@/components/sections/Stats";
import { ContactForm } from "@/components/sections/ContactForm";
import { useI18n } from "@/i18n/I18nProvider";

export default function Home() {
  const { t } = useI18n();

  useEffect(() => {
    document.title = t("meta.title");
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", t("meta.description"));
  }, [t]);

  return (
    <main id="main" data-testid="home-page">
      <Hero />
      <Marquee />
      <Editorial />
      <HowItWorks />
      <Projects />
      <Value />
      <Stats />
      <ContactForm />
    </main>
  );
}
